import { useMutation } from '@apollo/client';
import { useState } from 'react';
import { graphql } from '../../__generated__';

export const useSendMessage = (threadId: string) => {
  const [sending, setSending] = useState(false);

  const [sendMessageMutation] = useMutation(
    graphql(`
      mutation newMessageSend($threadId: ID, $message: String, $channel: String) {
        newMessage(threadId: $threadId, message: $message, channel: $channel) {
          __typename
          id
          assignedUser
          open
          channel
          identityChannel
          unreadDoctor
          unreadCustomer
          messages {
            __typename
            id
            sent
            senderID
            message
            final
            channel
            photo
            html
            title
            files
            type
            options
          }
          unreadDoctor
          unreadCustomer
        }
      }
    `),
  );

  const sendMessage = async (message: string, channel: 'sms' | 'app') => {
    setSending(true);

    await sendMessageMutation({
      variables: {
        threadId,
        channel,
        message,
      },
    });

    setSending(false);
  };

  return {
    sendMessage,
    sending,
    setSending,
  };
};
